import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, watch } from 'vue'

import Message from '@/client/components/_atoms/Message.vue'
import InDmChatArea from '@/client/components/_organisms/in_dm_chat_area'
import InDmFrame from '@/client/components/_organisms/in_dm_frame'
import { useInstagramScenarioPreviewStore } from '@/client/features/instagram_instantwin_prize/hooks/instagramScenarioPreviewStore'
import type { PreviewPattern } from '@/client/features/instagram_instantwin_prize/utils/buildPreviewChatItems'
import {
  PREVIEW_STEP_INTERVAL_SEC_MAX,
  PREVIEW_STEP_INTERVAL_SEC_MIN,
  PREVIEW_STEP_INTERVAL_SEC_STEP
} from '@/client/features/instagram_instantwin_prize/utils/previewConstants'
import type { NodeResponse } from '@/typings/api/instagram_instantwin_node_container'

interface Props {
  visible: boolean
  prizeId: number | null
}

interface Emits {
  (e: 'close'): void
}

type PreviewSelectNode = Extract<NodeResponse, { type: 'SELECT' }>


export default /*#__PURE__*/_defineComponent({
  __name: 'InstagramScenarioPreviewDialog',
  props: {
    visible: { type: Boolean },
    prizeId: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean
  prizeId: number | null
};




const store = useInstagramScenarioPreviewStore()

const PATTERN_OPTIONS: { value: PreviewPattern; label: string }[] = [
  { value: 'win', label: '当選' },
  { value: 'lose', label: '落選' },
  { value: 'unfollow', label: '未フォロー' },
  { value: 'missing', label: '離脱' }
]

const isControlDisabled = computed(() => store.playbackState === 'playing')

const visiblePatternOptions = computed(() =>
  PATTERN_OPTIONS.filter(option => {
    if (option.value === 'unfollow') return store.canShowUnfollow
    if (option.value === 'missing') return store.canShowMissing
    return true
  })
)

const chatAreaKey = computed(() => {
  const answerKey = Object.entries(store.answers)
    .map(([selectNodeId, optionId]) => `${selectNodeId}=${optionId}`)
    .join(',')
  return `${store.pattern}:${answerKey}`
})

function getAnswerValue(selectNode: PreviewSelectNode): number | null {
  return store.answers[selectNode.id] ?? selectNode.selectOption[0]?.id ?? null
}

function onPatternChange(next: PreviewPattern): void {
  store.setPattern(next)
}

function onAnswerChange(selectNodeId: number, optionId: number): void {
  store.setAnswer(selectNodeId, optionId)
}

const stepIntervalSec = computed(() => store.playbackControl.stepIntervalMs / 1000)

function onStepIntervalChange(nextSec: number): void {
  store.setStepIntervalMs(Math.round(nextSec * 1000))
}

function formatStepIntervalTooltip(sec: number): string {
  return `${sec.toFixed(1)} 秒`
}

watch(
  () => props.visible,
  async visible => {
    if (!visible) {
      store.close()
      return
    }
    if (props.prizeId === null) return
    await store.open(props.prizeId).catch(() => undefined)
  },
  { immediate: true }
)

onBeforeUnmount(() => {
  store.close()
})

function handleClose(): void {
  emit('close')
}

return { __sfc: true,props, emit, store, PATTERN_OPTIONS, isControlDisabled, visiblePatternOptions, chatAreaKey, getAnswerValue, onPatternChange, onAnswerChange, stepIntervalSec, onStepIntervalChange, formatStepIntervalTooltip, handleClose, Message, InDmChatArea, InDmFrame, PREVIEW_STEP_INTERVAL_SEC_MAX, PREVIEW_STEP_INTERVAL_SEC_MIN, PREVIEW_STEP_INTERVAL_SEC_STEP }
}

})